import React from "react";
import { motion } from "framer-motion";
import { CalendarDays, MapPin, ArrowUpRight } from "lucide-react";

const EventCard = ({ event }) => {
  const isPast = new Date(event.eventDate) < new Date();

  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ duration: 0.25 }}
      className="
        h-full
        overflow-hidden
        rounded-3xl
        border border-white/10
        bg-white/[0.03]
        backdrop-blur-xl
        group
        cursor-pointer
      "
      onClick={() => window.open(event.link, "_blank", "noopener,noreferrer")}
    >
      <div className="relative overflow-hidden">
        <img
          src={event.image}
          alt={event.title}
          className={`
            h-[180px] w-full object-cover
            transition-all duration-500
            group-hover:scale-105
            ${isPast ? "grayscale" : ""}
          `}
        />
      </div>

      <div className="flex h-[calc(100%-13rem)] flex-col p-4">
        <h3 className="mb-4 font-[Crimson] text-xl leading-tight text-white">
          {event.title}
        </h3>

        <div className="space-y-2 text-sm text-white/70">
          <div className="flex items-center gap-3">
            <CalendarDays size={16} className="text-reddark" />
            <span>
              {event.date}, {event.time}
            </span>
          </div>

          <div className="flex items-center gap-3">
            <MapPin size={16} className="text-reddark" />
            <span>{event.venue}</span>
          </div>
        </div>

        <div className="mt-auto flex items-center justify-between pt-3">
          {isPast ? (
            <div className="rounded-xl bg-gray-600 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white min-h-11 flex items-center">
              Sales Ended
            </div>
          ) : (
            <span className="text-md font-semibold text-white">
              {event.price}
            </span>
          )}

          <div
            className={`
    flex h-11 w-11 items-center justify-center rounded-xl
    ${isPast ? "bg-gray-600" : "bg-reddark"}
    transition-transform duration-300
    group-hover:translate-x-1
        group-hover:bg-reddark

    group-hover:-translate-y-1
  `}
          >
            <ArrowUpRight size={18} className="text-white" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default EventCard;
